<template>
    <div class="confirm-step-box">
        <div class="confirm-item" v-for="(item, index) in confirmList" :key="index">
            <div class="confirm-item-head">
                <div class="confirm-item-line"></div>
                <div class="confirm-item-text">{{ index + 1 }}</div>
            </div>
            <div class="confirm-item-content">
                <div class="item-content-main">
                    <div class="item-content-title">{{ item.title }}审核</div>
                    <div class="confirm-action" v-if="commentBtn">
                        <el-button type="primary" size="mini" @click="showComment">评论</el-button>
                    </div>
                </div>
                <div class="confirm-item-main" v-for="(user, index) in item.users" :key="index">
                    <div class="main-title">
                        <div class="item-content-title">{{ user.realname }}</div>
                        <div class="main-more" v-if="user.status">
                            <span :style="{ color: status[user.status].color }">{{ status[user.status].title }}</span>
                            <span style="margin-left: 10px">{{ user.audit_time }}</span>
                        </div>
                    </div>
                    <div class="item-content-text" v-if="user.reamrk">{{ user.reamrk }}</div>
                </div>
            </div>
        </div>

        <div class="comment-dialog">
            <el-dialog title="评论" :visible.sync="dialog" :append-to-body="true" :before-close="closeDialog" width="30%">
                <el-form :model="commentForm" ref="commentForm" :rules="rules" label-width="100px" label-position="left">
                    <el-form-item label="评论内容：" prop="comment">
                        <el-input v-model="commentForm.comment" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeDialog">取 消</el-button>
                    <el-button type="primary" @click="submit">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    name: 'step',
    props: {
        confirmList: {
            type: Array,
            default: []
        },
        commentBtn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialog: false,
            commentForm: {
                comment: ''
            },
            status: {
                0: {
                    title: '待审核',
                    color: '#999'
                },
                1: {
                    title: '审核通过',
                    color: '#409EFF'
                },
                2: {
                    title: '审核驳回',
                    color: 'red'
                },
                3: {
                    title: '已转交',
                    color: '#999'
                },
                13: {
                    title: '已撤销',
                    color: '#999'
                }
            },
            rules: {
                comment: [{ required: true, message: '请输入内容', trigger: 'blur' }]
            }
        };
    },
    methods: {
        // 显示评论弹窗
        showComment() {
            this.dialog = true;
        },
        // 关闭
        closeDialog() {
            this.dialog = false;
            this.commentForm = {
                comment: ''
            };
        },
        // 提交评论
        submit() {
            let that = this;
            that.$refs['commentForm'].validate((valid) => {
                if (valid) {
                    that.$message.success('评论成功');
                    that.closeDialog();
                } else {
                    that.$message('请检查您的填写');
                }
            });
        }
    }
};
</script>

<style scoped>
.confirm-step-box {
    display: flex;
    flex-flow: column;
}

.confirm-step-box .confirm-item {
    position: relative;
    display: flex;
    flex-shrink: 1;
}

.confirm-item-head {
    position: relative;
    flex-grow: 0;
}

.confirm-item-line {
    position: absolute;
    width: 2px;
    top: 0;
    bottom: 0;
    left: 11px;
    border-color: inherit;
    background-color: #c0c4cc;
}

.confirm-item-text {
    position: relative;
    z-index: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    background: #fff;
    border: 2px solid #ebedf0;
    border-radius: 50%;
    font-size: 12px;
}

.confirm-item-content {
    padding-left: 10px;
    padding-bottom: 20px;
    white-space: normal;
    flex: 1;
    flex-grow: 1;
    text-align: left;
}

.item-content-main {
    padding-bottom: 3px;
    display: flex;
    cursor: pointer;
}

.confirm-item-content:hover .confirm-action {
    display: block;
}

.main-title {
    display: flex;
}

.main-more {
    flex: 1;
    text-align: end;
}

.item-content-title {
    width: 8rem;
    line-height: 24px;
    font-size: 14px;
    color: #333;
}

.confirm-action {
    display: none;
    flex: 1;
    text-align: end;
}

.confirm-action button {
    padding: 4px 9px;
}

.item-content-text {
    font-size: 12px;
    color: #c0c4cc;
}
</style>